(function () {
  // ------- helpers -------
  const fmtMoney = (cents, locale = 'es-CO', currency = 'COP') =>
    new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: 0 }).format((cents || 0) / 100);

  const computeProgress = (totalCents, thresholdCents) => {
    if (!thresholdCents) return 0;
    return Math.max(0, Math.min(100, (totalCents / thresholdCents) * 100));
  };

  const fetchCart = () =>
    fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } }).then((r) => r.json());

  // ------- core -------
  const updateOneBar = (el, cart) => {
    const threshold = parseInt(el.getAttribute('data-threshold'), 10) || 174000; // COP
    const locale = el.getAttribute('data-locale') || 'es-CO';
    const currency = el.getAttribute('data-currency') || 'COP';
    const thresholdCents = threshold * 100;
    const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;

    const msgEl = el.querySelector('[data-msg]');
    const fillEl = el.querySelector('.titta-freeship__fill');
    const truckEl = el.querySelector('.titta-freeship__truck');
    const barEl = el.querySelector('.titta-freeship__bar');

    if (!msgEl || !fillEl || !truckEl || !barEl) return;

    // progreso
    const progress = computeProgress(total, thresholdCents);
    fillEl.style.width = progress + '%';

    // estados y mensajes
    if (total <= 0) {
      // --- carrito vacío ---
      el.classList.add('is-empty');
      el.classList.remove('titta-freeship--reached');
      msgEl.innerHTML = 'Envios Gratis desde <strong>' + fmtMoney(thresholdCents, locale, currency) + '</strong>';
      truckEl.style.opacity = '0';
    } else if (total >= thresholdCents) {
      // --- alcanzó envío gratis ---
      el.classList.remove('is-empty');
      el.classList.add('titta-freeship--reached');
      msgEl.innerHTML = '¡Listo! Tu envío es <strong>GRATIS</strong>.';
      truckEl.style.opacity = '1';
    } else {
      // --- en progreso ---
      el.classList.remove('is-empty');
      el.classList.remove('titta-freeship--reached');
      const diff = thresholdCents - total;
      msgEl.innerHTML =
        '¡Ya casi! Te faltan <strong>' +
        fmtMoney(diff, locale, currency) +
        '</strong> para tu envío <strong>GRATIS</strong>.';
      truckEl.style.opacity = '1';
    }

    // posición del camión con límites para que no se corte
    const barWidth = barEl.getBoundingClientRect().width || 0;
    const minOffset = 8; // px desde el borde izquierdo
    const maxOffset = Math.max(minOffset, barWidth - 8); // px desde el derecho
    const rawOffset = (progress / 100) * barWidth;
    const clamped = Math.max(minOffset, Math.min(maxOffset, rawOffset));
    truckEl.style.left = clamped + 'px';
  };

  const updateAllBars = async () => {
    const bars = document.querySelectorAll('.titta-freeship');
    if (!bars.length) return;
    try {
      const cart = await fetchCart();
      bars.forEach((el) => updateOneBar(el, cart));
    } catch (_e) {
      bars.forEach((el) => updateOneBar(el, { total_price: 0 }));
    }
  };

  // ------- listeners -------
  document.addEventListener('DOMContentLoaded', updateAllBars);
  document.addEventListener('cart:updated', updateAllBars);

  // tras añadir al carrito vía formulario
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      setTimeout(updateAllBars, 700);
      setTimeout(updateAllBars, 1500);
    }
  });

  // cambios de cantidades en carritos
  document.addEventListener('change', (e) => {
    if (e.target && (e.target.name === 'updates[]' || e.target.closest('[name="updates[]"]'))) {
      setTimeout(updateAllBars, 500);
      setTimeout(updateAllBars, 1200);
    }
  });

  // eventos del editor de secciones
  document.addEventListener('shopify:section:load', updateAllBars);
  document.addEventListener('shopify:section:select', updateAllBars);
  document.addEventListener('shopify:section:deselect', updateAllBars);

  // API global opcional
  window.TittaFreeShipUpdate = updateAllBars;
})();
